module.exports = __webpack_public_path__ + "static/media/districts_map.4739595a.svg";